import pasado from "./Pasado.json";
import already from "./already.json";
import PresentPerfectContinuous from "./pperfectcont.json";
import HowLong from "./howlong.json";
import PerfectvsContinuous from "./ppsvsppc.json";
import prefix from './prefix.json';
import articles from "./articles.json";
import reflexive from "./reflexive.json";
import gerundios from "./gerundios.json";
import verbpatterns from "./verbpatterns.json";
import continuousplans from "./continuousplans.json";
import goingto from "./goingto.json";
import willvsgoing from "./willvsgoing.json";
import might from "./might.json";

export const GRAMMAR_M8 = [
    ...pasado,
    ...already,
    ...PresentPerfectContinuous,
    ...HowLong,
    ...PerfectvsContinuous,
    ...prefix,
    ...articles,
    ...reflexive,
    ...gerundios,
    ...verbpatterns,
    ...continuousplans,
    ...goingto,
    ...willvsgoing,
    ...might,
    ];
